import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFourSquaresIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{clip-path:url(#SVGID_00000167356224768629991030000015685617295591006358_);}\n	.st1{opacity:0.2;fill:#1557b5;enable-background:new    ;}\n	.st2{fill:none;stroke:#0f172b;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("rect", {
			id: "SVGID_1_",
			width: 24,
			height: 24
		}) }),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "SVGID_00000143590214700877545460000010306969232215448765_",
			children: /* @__PURE__ */ _jsx("use", {
				xlinkHref: "#SVGID_1_",
				style: { overflow: "visible" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { clipPath: "url(#SVGID_00000143590214700877545460000010306969232215448765_)" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "st1",
					d: "M12,12H4.1V4.9c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2H12V12z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st2",
					d: "M19.1,4.1H4.9c-0.4,0-0.8,0.3-0.8,0.8v14.2c0,0.4,0.3,0.8,0.8,0.8h14.2c0.4,0,0.8-0.3,0.8-0.8V4.9 C19.9,4.5,19.5,4.1,19.1,4.1z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st2",
					d: "M12,4.1v15.8"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "st2",
					d: "M19.9,12H4.1"
				})
			]
		})
	] })]
});
export default SvgFourSquaresIcon;
